import React, { Component } from 'react';
import { Router, Route, browserHistory } from 'react-router';
import {FormattedHTMLMessage} from 'react-intl';
var moment = require('moment');
import 'react-dates/initialize';
import MainContainer from '../containers/MainContainer';
import WinecellarContainer from '../containers/WinecellarContainer';
import CbuContainer from '../containers/CbuContainer';
import SmsContainer from '../containers/SmsContainer';
import ProductContainer from '../containers/ProductContainer';
import AddressContainer from '../containers/AddressContainer';
import AddressConfirmFormContainer from '../containers/AddressConfirmFormContainer';
import AddressConfirmPryFormContainer from '../containers/AddressConfirmPryFormContainer'
import PryAddressContainer from '../containers/PryAddressContainer';
import PendingContainer from '../containers/PendingContainer';
import JobInfoFormContainer from '../containers/JobInfoFormContainer';
import EmailFormContainer from '../containers/EmailFormContainer';
import ServiceInfoFormContainer from '../containers/ServiceInfoFormContainer';
import PersonalInfoFormContainer from '../containers/PersonalInfoFormContainer';
import IncomesFormContainer from '../containers/IncomesFormContainer';
import UploadFormContainer from '../containers/UploadFormContainer';
import EmailVerificationContainer from '../containers/EmailVerificationContainer';
import Congratulations from './Congratulations';
import DocumentsContainer from '../containers/DocumentsContainer';
import DepositFormContainer from '../containers/DepositFormContainer';
import CreditCardFormContainer from '../containers/CreditCardFormContainer';
import AdditionalPersonalInfoFormContainer from "../containers/AdditionalPersonalInfoFormContainer";
import RenaperContainer from "../containers/RenaperContainer";
import LoanTypeFormContainer from '../containers/LoanTypeFormContainer';
import Greetings from './Greetings';
import Rejected from './Rejected';
import RejectedVineyards from './RejectedVineyards';
import RejectedInvestment from './RejectedInvestment';
import Inspected from './Inspected';
import Disapproved from './Disapproved';
import CheckOut from './CheckOut';
import { HotKeys } from "react-hotkeys";
import MembersContainer from '../containers/MembersContainer';
import VineyardsContainer from '../containers/VineyardsContainer';
import VineyardTypesFormContainer from '../containers/VineyardTypesFormContainer';
import WarrantyFormContainer from '../containers/WarrantyFormContainer';
import CAWarrantyFormContainer from '../containers/CAWarrantyFormContainer';
import GuarantorFormContainer from '../containers/GuarantorFormContainer';
import GuarantorInfoFormContainer from '../containers/GuarantorInfoFormContainer';
import SuretyFormContainer from '../containers/SuretyFormContainer';
import GeneralWarrantyFormContainer from '../containers/GeneralWarrantyFormContainer';
import CheckAddrressFormContainer from '../containers/CheckAddressFormContainer';
import AmountFormContainer from '../containers/AmountFormContainer';
import CheckDpjNumberFormContainer from '../containers/CheckDpjNumberFormContainer';
import CooperativeCompanyFormContainer from '../containers/CooperativeCompanyFormContainer';
import CompanyRepresentativeFormContainer from '../containers/CompanyRepresentativeFormContainer';
import CooperativeRepresentativesFormContainer from '../containers/CooperativeRepresentativesFormContainer';
import DpjFormContainer from '../containers/DpjFormContainer';
import AvailableAmountFormContainer from '../containers/AvailableAmountFormContainer';
import ProductionAmountsFormContainer from '../containers/ProductionAmountsFormContainer';
import StartupFormContainer from '../containers/StartupFormContainer';
import AttorneyFormContainer from '../containers/AttorneyFormContainer';
import LoanLineFormContainer from '../containers/LoanLineFormContainer';
import CompanyTypeFormContainer from '../containers/CompanyTypeFormContainer'
import LastSalesFormContainer from '../containers/LastSalesFormContainer';
import PropertyFormContainer from '../containers/PropertyFormContainer';
import LoanReasonFormContainer from '../containers/LoanReasonFormContainer';
import LoanDescriptionFormContainer from '../containers/LoanDescriptionFormContainer';
import PryRolFormContainer from '../containers/PryRolFormContainer';
import MzaActiveContainer from '../containers/MzaActiveContainer';
import ElectronicWalletContainer from '../containers/ElectronicWalletContainer';
import Whatsapp from './WhatsappButton.js';

const keyMap = {
    SHOW_SELLER_CODE: "shift+c"
  };

var ReactGA = require('react-ga');
ReactGA.initialize(null);
export { ReactGA };
moment.locale('es');

function logPageView() {
    ReactGA.set({ page: window.location.pathname + window.location.search });
    ReactGA.pageview(window.location.pathname + window.location.search);
}

export default class App extends Component {

    render() {
        return (
            <HotKeys keyMap={keyMap}>
            <div className="App">
                <div className="pd-content">
                    <Router history={browserHistory} >
                        <Route path="/" component={MainContainer} onEnter={logPageView} />
                        <Route path="/electronic-wallet" component={ElectronicWalletContainer} onEnter={logPageView} />
                        <Route path="/mza-active" component={MzaActiveContainer} onEnter={logPageView} />
                        <Route path="/pry-rol" component={PryRolFormContainer} onEnter={logPageView} />
                        <Route path="/loan-description" component={LoanDescriptionFormContainer} onEnter={logPageView} />
                        <Route path="/loan-reason" component={LoanReasonFormContainer} onEnter={logPageView} />
                        <Route path="/startup" component={StartupFormContainer} onEnter={logPageView} />
                        <Route path="/attorney" component={AttorneyFormContainer} onEnter={logPageView} />
                        <Route path="/loan-line" component={LoanLineFormContainer} onEnter={logPageView} />
                        <Route path="/last-sales" component={LastSalesFormContainer} onEnter={logPageView} />
                        <Route path="/property" component={PropertyFormContainer} onEnter={logPageView} />
                        <Route path="/guarantor-type" component={GuarantorFormContainer} onEnter={logPageView} />
                        <Route path="/guarantor" component={GuarantorInfoFormContainer} onEnter={logPageView} />
                        <Route path="/surety" component={SuretyFormContainer} onEnter={logPageView} />
                        <Route path="/warranty" component={WarrantyFormContainer} onEnter={logPageView} />
                        <Route path="/ca-warranty" component={CAWarrantyFormContainer} onEnter={logPageView} />
                        <Route path="/general-warranty" component={GeneralWarrantyFormContainer} onEnter={logPageView} />
                        <Route path="/email" component={EmailVerificationContainer} onEnter={logPageView} />
                        <Route path="/incomes" component={IncomesFormContainer} onEnter={logPageView} />
                        <Route path="/job-info" component={JobInfoFormContainer} onEnter={logPageView} />
                        <Route path="/add-email" component={EmailFormContainer} onEnter={logPageView} />
                        <Route path="/personal-info" component={PersonalInfoFormContainer} onEnter={logPageView} />
                        <Route path="/additional-personal-info" component={AdditionalPersonalInfoFormContainer} onEnter={logPageView} />
                        <Route path="/service-info" component={ServiceInfoFormContainer} onEnter={logPageView} />
                        <Route path="/uploads" component={UploadFormContainer} onEnter={logPageView} />
                        <Route path="/cbu" component={CbuContainer} onEnter={logPageView} />
                        <Route path="/renaper" component={RenaperContainer} onEnter={logPageView} />
                        <Route path="/sms" component={SmsContainer} onEnter={logPageView} />
                        <Route path="/winecellar-info" component={WinecellarContainer} onEnter={logPageView} />
                        <Route path="/members" component={MembersContainer} onEnter={logPageView} />
                        <Route path="/vineyards" component={VineyardsContainer} onEnter={logPageView} />
                        <Route path="/vineyard-types" component={VineyardTypesFormContainer} onEnter={logPageView} />
                        <Route path="/address" component={AddressContainer} onEnter={logPageView} />
                        <Route path="/address-confirm" component={AddressConfirmFormContainer} onEnter={logPageView} />
                        <Route path="/address-confirm-pry" component={AddressConfirmPryFormContainer} onEnter={logPageView} />
                        <Route path="/pry-address" component={PryAddressContainer} onEnter={logPageView} />
                        <Route path="/check-address" component={CheckAddrressFormContainer} onEnter={logPageView} />
                        <Route path="/check-dpj-number" component={CheckDpjNumberFormContainer} onEnter={logPageView} />
                        <Route path="/dpj-number" component={DpjFormContainer} onEnter={logPageView} />
                        <Route path="/cooperative-company" component={CooperativeCompanyFormContainer} onEnter={logPageView} />
                        <Route path="/company-representative" component={CompanyRepresentativeFormContainer} onEnter={logPageView} />
                        <Route path="/cooperative-representatives" component={CooperativeRepresentativesFormContainer} onEnter={logPageView} />
                        <Route path="/amount" component={AmountFormContainer} onEnter={logPageView} />
                        <Route path="/available-amount" component={AvailableAmountFormContainer} onEnter={logPageView} />
                        <Route path="/production-amounts" component={ProductionAmountsFormContainer} onEnter={logPageView} />
                        <Route path="/product" component={ProductContainer} onEnter={logPageView} />
                        <Route path="/documents" component={DocumentsContainer} onEnter={logPageView} />
                        <Route path="/deposit" component={DepositFormContainer} onEnter={logPageView} />
                        <Route path="/credit-card" component={CreditCardFormContainer} onEnter={logPageView} />
                        <Route path="/loan-type" component={LoanTypeFormContainer} onEnter={logPageView} />
                        <Route path="/company-type" component={CompanyTypeFormContainer} onEnter={logPageView} />
                        <Route path="/rejected-vineyards" component={RejectedVineyards} onEnter={logPageView} />
                        <Route path="/rejected-investment" component={RejectedInvestment} onEnter={logPageView} />
                        <Route path="/pending" component={PendingContainer} onEnter={logPageView} />
                        <Route path="/checkout" component={CheckOut} onEnter={logPageView} />
                        <Route path="/congratulations" component={Congratulations} onEnter={logPageView} />
                        <Route path="/rejected" component={Rejected} onEnter={logPageView} />
                        <Route path="/inspected" component={Inspected} onEnter={logPageView} />
                        <Route path="/disapproved" component={Disapproved} onEnter={logPageView} />
                        <Route path="/greetings" component={Greetings} onEnter={logPageView} />
                    </Router>
                </div>
                <Whatsapp number={"2617737228"} text="Hola, tengo una consulta." gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping" gaLabel="261-7737-228" />
                <div className={'main-padding'}></div>
                <footer>
                <div id="footer-bottom">
                        <div className="footer_sign">
                            <FormattedHTMLMessage
                                id="app.footer-copyright"
                                description="Describe Copyright" />
                                {new Date().getFullYear()}
                            <FormattedHTMLMessage
                                id="app.footer-sign"
                                description="Datos de la empresa" />
                        </div>
                </div>
                </footer>
            </div>
            </HotKeys>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/